import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
const DateField = dynamic(() => import('@/components/common/form/fields/DateField'), { ssr: false });
DateField.displayName = 'DateField';
import CheckboxField from '@/components/common/form/fields/CheckboxField';
import EmailField from '@/components/common/form/fields/EmailField';
import PasswordField from '@/components/common/form/fields/PasswordField';
import PhoneField from '@/components/common/form/fields/PhoneField';
import PostalCodeField from '@/components/common/form/fields/PostalCodeField';
import RadioField from '@/components/common/form/fields/RadioField';
import SelectField from '@/components/common/form/fields/SelectField';
import TextField from '@/components/common/form/fields/TextField';
import { FIELD_TYPE, SUPPORTED_TYPES, TEXT_TYPES } from '@/constants/form';

const FIELDS_COMPONENT = {
  [FIELD_TYPE.POSTAL_CODE]: PostalCodeField,
  [FIELD_TYPE.PASSWORD]: PasswordField,
  [FIELD_TYPE.CHECKBOX]: CheckboxField,
  [FIELD_TYPE.SELECT]: SelectField,
  [FIELD_TYPE.EMAIL]: EmailField,
  [FIELD_TYPE.PHONE]: PhoneField,
  [FIELD_TYPE.RADIO]: RadioField,
  [FIELD_TYPE.DATE]: DateField
};

export const FormField = ({ type, label = '', isRequired = false, ...rest }) => {
  let Component;
  let componentProps = { isRequired, ...rest };

  if (!SUPPORTED_TYPES.includes(type)) {
    throw new Error(`The input type "${type}" is not handled`);
  }

  if (TEXT_TYPES.includes(type)) {
    Component = TextField;
    componentProps = { type, ...componentProps };
  } else {
    Component = FIELDS_COMPONENT[type];
    componentProps = { type, ...componentProps };
  }

  // The CheckboxField must not be wrapped in a .form-group div
  return type === FIELD_TYPE.CHECKBOX ? (
    <Component label={label} {...componentProps} />
  ) : (
    <div className="form-group" data-rbf={componentProps?.rbf}>
      {label && (
        <label className="form-label">{label}{isRequired && '*'}</label>
      )}
      <Component {...componentProps} />
    </div>
  );
};

FormField.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  country: PropTypes.string
};

export default FormField;
